import el from "@cypherpotato/el";
import page from "page";
import { api } from "../../api";
import { PrimaryButton } from "../../components/button";
import { FormControl, TextInput } from "../../components/form";
import { Icon } from "../../components/icon";
import { ExternalLink } from "../../components/link";
import { runOperation } from "../../ui/operation";
import { LoginLayout } from "./login-layout";

const supportUrl = "https://aivax.net/contact/";
const confirmation = "If an account exists for that e-mail, we sent a message with a one-time sign-in link and a link to reset your login key.";

export default function () {
    const email = el.state.create("");
    const message = el.state.create(null);

    async function submit(event) {
        event.preventDefault();
        const address = email.value.trim();
        if (!/\S+@\S+\.\S+/.test(address)) {
            message.value = { type: "error", text: "Enter the e-mail address used to register." };
            return;
        }

        await runOperation("Sending recovery e-mail...", async () => {
            const result = await api.postJson("/api/v1/auth/recovery", { email: address }, { suppressError: true });
            message.value = result?.error
                ? { type: "error", text: result.error }
                : { type: "success", text: result?.data?.confirmation || confirmation };
        });
    }

    return LoginLayout(
        el("form.login-form", { onSubmit: submit },
            el("header.login-form-header",
                el("h1", "Recover login key"),
                el("p", "Enter the e-mail address used to register. We will send the same confirmation whether or not an account exists.")
            ),
            el("div.register-fields",
                FormControl(
                    "E-mail",
                    TextInput("email", "you@example.com", {
                        type: "email",
                        autocomplete: "email",
                        onInput() {
                            email.value = this.value;
                        }
                    })
                )
            ),
            el.state.listening([message], () => {
                const current = message.value;
                return el("div.login-form-message",
                    { classList: [current?.type], "aria-live": "polite" },
                    current && Icon(current.type === "success" ? "check-line" : "error-warning-line"),
                    current?.text || ""
                );
            }),
            el.state.listening([email], () =>
                PrimaryButton(
                    el("span", "Send recovery e-mail"),
                    Icon("arrow-right-line"),
                    {
                        classList: ["login-submit"],
                        type: "submit",
                        disabled: !/\S+@\S+\.\S+/.test(email.value.trim())
                    }
                )
            ),
            ExternalLink("I don't remember or no longer have access to my e-mail", supportUrl, { rel: "noreferrer" }),
            el("div.login-register-row",
                el("a.app-link[href='/login/help']", "Back", {
                    onClick(event) {
                        event.preventDefault();
                        page("/login/help");
                    }
                })
            )
        )
    );
}
